import { FormProvider, UseFormReturn } from 'react-hook-form';
import { Stack } from '@chakra-ui/react';

import { ShineRecurringAccountingExportSettingsType } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';

import { AccountingExportSchema } from './accountingExport.schema';
import { Frequency } from './components/Frequency';
import { Options } from './components/Options';
import { Recipients } from './components/Recipients';
import { TypeCards } from './components/TypeCards';

interface AccountingExportFormProps {
  form: UseFormReturn<AccountingExportSchema>;
  isEdit?: boolean;
}

export const AccountingExportForm = ({
  form,
  isEdit,
}: AccountingExportFormProps) => {
  const type = form.watch('type');

  return (
    <FormProvider {...form}>
      <Stack gap="space-40">
        {!isEdit ? <TypeCards /> : null}

        <SunshineCard.Group>
          <Options />

          {type ===
          ShineRecurringAccountingExportSettingsType.ShineRecurring ? (
            <Frequency />
          ) : null}

          <Recipients />
        </SunshineCard.Group>
      </Stack>
    </FormProvider>
  );
};
